<template>
    <div>
            <div class="heading-travel-policy">
                <span :class="carSizeObj.isActive?'tag is-success':'tag'">Standard rule</span> 
                
                <div class="right-content">
                    <div class="lefttext">
                        <p class="paragrapgh">Car size</p>
                        <p>Trigger when the vehicle size is above:
                            <span class="rule-config-variable" @click="isEdit = !isEdit">
                                {{ $helpers.getCarSizeName(carSizeObj.value) }}
                                <b-icon icon="pencil" size="is-small" ></b-icon> 
                            </span>
                        </p>
                    </div>
                    <div class="allbtns">
                        <b-switch 
                            :rounded="true" 
                            :value="carSizeObj.isActive" 
                            v-model="carSizeObj.isActive"
                            @input="carSizeGreaterThan" 
                            :left-label="true"
                            >{{ carSizeObj.isActive ? 'Active' : 'Inactive' }}
                        </b-switch>
                    </div>
                </div>
            </div>
            <div v-if="isEdit" class="edittravelpolicy">
                <CarSize @carSize="getValue" :carsizeis="carSizeObj.value"/>
                <p>Select car size</p>
                <b-button @click="saveCall">SAVE</b-button>
            </div>
    </div>
</template>
<script>
import CarSize from '../CommonRules/CarSize.vue';
export default{
       name:"",
       props: {
    value: {
      type: [Object],
    },
  },
       components:{CarSize},
       data(){
        return{
            carSizeObj:this.value?this.value:{
                    name: "carSizeGreaterThan",
                    isActive: false,
                    value: 'I',
                    type:'car',
                    message:'',
            },
            isEdit:false,
            emitedValue : null
        }
       },
    methods:{
        saveCall(){
            this.isEdit = false;
            if(this.emitedValue || this.emitedValue=='') {
                this.carSizeObj.value = this.emitedValue;
            }
        },
        getValue(val) {
          this.emitedValue = val;
        },
        carSizeGreaterThan(){
            this.carSizeObj.message=this.buildMessage;

            this.$emit('carSizeGreaterThan',this.carSizeObj)
        }
    },
    mounted(){
        this.carSizeObj.type='car';
        this.carSizeObj.message=this.buildMessage;

        this.$emit('carSizeGreaterThan',this.carSizeObj)
    },
    computed:{
        buildMessage(){

            var string ='Trigger when the vehicle size is above ';

            return string + this.carSizeObj.value;
        }
    },
    watch: {
    value: {
      handler(newVal, prevVal) {
        this.carSizeObj = this.value;
        this.carSizeObj.type='car';
        this.carSizeObj.message=this.buildMessage;
        this.$emit('carSizeGreaterThan',this.carSizeObj);

      },
      deep: true,
    },
  },
}
</script>